const name = 'Sahidur Rahman Suman';

console.log('Hello', name);